import lloydsIllustrationBanking from '../../assets/common/lloyds-illustration-banking.svg';
import { AppContent } from '../AppContent';

const triageStartPage: AppContent['triageStartPage'] = {
  triageStartPageContent: [
    {
      imageSrc: lloydsIllustrationBanking,
      imageAltText: 'Lloyds Online Banking',
      description1: 'There’s a new way to register for Online for Business.',
      description2:
        'Let’s start with a few questions to make sure it’s right for you.',
      nextButton: 'Get started',
      nextBtnHref: '/full-signatory',
      previousLink: 'Previous',
      previousHref:
        'https://www.lloydsbank.com/business/banking-online/online-for-business/register-for-online-for-business.html',
    },
  ],
};

export default triageStartPage;
